var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "loginForm",
      attrs: {
        model: _vm.credentials,
        rules: _vm.rules,
        "label-width": "0em",
        "label-position": "left"
      }
    },
    [
      _vm.itemVisible("title", _vm.mode)
        ? [
            _c("h1", { staticStyle: { "text-align": "center" } }, [
              _vm._v(_vm._s(_vm.title))
            ])
          ]
        : _vm._e(),
      _vm.itemVisible("customanswer", _vm.mode)
        ? [
            _c("div", { staticClass: "explanation-title" }, [
              _vm._v("▮ 確認コードについて")
            ]),
            _c("div", { staticClass: "explanation" }, [
              _vm._v("・メールで通知されるコードを入力してください")
            ]),
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "確認コード",
                    clearable: true,
                    maxlength: 6,
                    autofocus: _vm.autofocus
                  },
                  model: {
                    value: _vm.customanswer,
                    callback: function($$v) {
                      _vm.customanswer = $$v
                    },
                    expression: "customanswer"
                  }
                })
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.itemVisible("userId", _vm.mode)
        ? [
            _c(
              "el-form-item",
              { staticClass: "user-id", attrs: { prop: "userId" } },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "ユーザーID",
                    "prefix-icon": "el-icon-user"
                  },
                  model: {
                    value: _vm.credentials.userId,
                    callback: function($$v) {
                      _vm.$set(_vm.credentials, "userId", $$v)
                    },
                    expression: "credentials.userId"
                  }
                })
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.itemVisible("userIdComment", _vm.mode)
        ? [
            _c("div", { staticClass: "explanation" }, [
              _vm._v("当画面にてユーザーIDを入力すると登録されている")
            ]),
            _c("div", { staticClass: "explanation" }, [
              _vm._v("メールアドレスへ確認コードがメール送付されます。")
            ]),
            _c("div", { staticClass: "explanation" }, [
              _vm._v("次画面で通知された確認コードを入力しパスワード")
            ]),
            _c("div", { staticClass: "explanation" }, [
              _vm._v("を変更してください。")
            ])
          ]
        : _vm._e(),
      _vm.itemVisible("newpassword", _vm.mode)
        ? [
            _c("div", { staticClass: "explanation-title" }, [
              _vm._v("▮ 新パスワードについて")
            ]),
            _c("div", { staticClass: "explanation" }, [
              _vm._v("・8文字以上で指定してください")
            ]),
            _c("div", { staticClass: "explanation" }, [
              _vm._v("・半角英字、数字、記号を含めてください")
            ]),
            _c("div", { staticClass: "explanation" }, [
              _vm._v("・利用可能な記号 !#$%&=~/*-+@")
            ]),
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  attrs: {
                    type: "password",
                    placeholder: "パスワード",
                    clearable: true,
                    maxlength: 20,
                    autofocus: _vm.autofocus,
                    "show-password": "",
                    "prefix-icon": "el-icon-lock"
                  },
                  model: {
                    value: _vm.newpassword,
                    callback: function($$v) {
                      _vm.newpassword = $$v
                    },
                    expression: "newpassword"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "explanation" }, [
              _vm._v("・新パスワードを再度入力してください")
            ])
          ]
        : _vm._e(),
      _vm.itemVisible("password", _vm.mode)
        ? [
            _c(
              "el-form-item",
              { staticClass: "password", attrs: { prop: "password" } },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "パスワード",
                    maxlength: 20,
                    "show-password": "",
                    "prefix-icon": "el-icon-lock"
                  },
                  model: {
                    value: _vm.credentials.password,
                    callback: function($$v) {
                      _vm.$set(_vm.credentials, "password", $$v)
                    },
                    expression: "credentials.password"
                  }
                })
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.itemVisible("LoginButton", _vm.mode)
        ? [
            _c(
              "el-row",
              [
                _c("el-col", [
                  _c(
                    "div",
                    { staticClass: "login-button" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.clickLogin($event)
                            }
                          }
                        },
                        [_vm._v("ログイン")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c("el-col", [
                  _c(
                    "div",
                    { staticClass: "forgotPassword" },
                    [
                      _c(
                        "el-link",
                        {
                          attrs: { type: "danger" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.resetPassword($event)
                            }
                          }
                        },
                        [_vm._v("パスワードを忘れた場合は、ここをクリック")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.itemVisible("ChangeButton", _vm.mode)
        ? [
            _c(
              "el-row",
              [
                _c("el-col", [
                  _c(
                    "div",
                    { staticClass: "login-button" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.cancel }
                        },
                        [_vm._v("戻る")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.changePassword($event)
                            }
                          }
                        },
                        [_vm._v("パスワード変更")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.itemVisible("NextButton", _vm.mode)
        ? [
            _c(
              "el-row",
              [
                _c("el-col", [
                  _c(
                    "div",
                    { staticClass: "login-button" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.cancel }
                        },
                        [_vm._v("戻る")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.next($event)
                            }
                          }
                        },
                        [_vm._v("次へ")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.itemVisible("ConfirmButton", _vm.mode)
        ? [
            _c("el-row", [
              _c(
                "div",
                { staticClass: "login-button" },
                [
                  _c("el-col", [
                    _c(
                      "div",
                      { staticClass: "login-button" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.cancel }
                          },
                          [_vm._v("戻る")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onetime }
                          },
                          [_vm._v("確認")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }